/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualDid: core.serialization.ObjectSchema<serializers.NotEqualDid.Raw, Truvity.NotEqualDid> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace NotEqualDid {
    export interface Raw {
        value: string;
    }
}
